import apiClient from './apiClient';
import {
  STRIPE_CHECKOUT,
  STRIPE_CUSTOMER_PORTAL,
  STRIPE_CONNECT_ONBOARDING_LINK
} from '../constants/UriConstants';

export interface StripeOnboardingLinkResponse {
  onboarding_url: string;
  account_id: string;
}

export const stripeCheckout = (): Promise<string> =>
  apiClient
    .post(STRIPE_CHECKOUT, { packages: [{ priceID: process.env.REACT_APP_STRIPE_PRICE_ID, quantity: 1 }] })
    .then((response) => response.data);

export const getStripeCustomerPortal = (): Promise<string> =>
  apiClient.get(STRIPE_CUSTOMER_PORTAL).then((response) => response.data);

export const getStripeConnectOnboardingLink = (): Promise<StripeOnboardingLinkResponse> =>
  apiClient.post(STRIPE_CONNECT_ONBOARDING_LINK).then((response) => response.data);
